import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCkjNZMw3X7brtoqtRGYggLW43F1Zs-SW8",
  authDomain: "clone-554ae.firebaseapp.com",
  projectId: "clone-554ae",
  storageBucket: "clone-554ae.appspot.com",
  messagingSenderId: "734135552924",
  appId: "1:734135552924:web:7d3f8e3350bbd62b45d659"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
